/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Spanish14Inputs */

const en__field_enum_subject_spanish14 = /** @type {(inputs: _Field_Enum_Subject_Spanish14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish`)
};

const de__field_enum_subject_spanish14 = /** @type {(inputs: _Field_Enum_Subject_Spanish14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanisch`)
};

/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {_Field_Enum_Subject_Spanish14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_spanish14 = /** @type {((inputs?: _Field_Enum_Subject_Spanish14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Spanish14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_spanish14(inputs)
	return de__field_enum_subject_spanish14(inputs)
});
export { _field_enum_subject_spanish14 as "_field_enum_SUBJECT_SPANISH" }